import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Image } from "@silvertours/common-landingpages-view";
import { Ui } from "@silvertours/front-shared";
import { Badge, ModuleContainer } from "../element";
export var ImageContentBlock = function(param) {
    var _content = param.content, badge = _content.badge, image = _content.image, rules = param.rules;
    if (!image) {
        return null;
    }
    var ref = rules || {}, badgeRules = ref.badge, imagePosition = ref.imagePosition, isFirstColumn = ref.isFirstColumn, verticalSpacing = ref.verticalSpacing;
    return /*#__PURE__*/ _jsxs(ModuleContainer, {
        rules: {
            isFirstColumn: isFirstColumn,
            verticalSpacing: verticalSpacing
        },
        children: [
            /*#__PURE__*/ _jsx(Badge, {
                content: badge,
                rules: {
                    badge: badgeRules,
                    verticalSpacing: {
                        isLargeAtMD: true
                    }
                }
            }),
            /*#__PURE__*/ _jsx(Ui.Image, _object_spread_props(_object_spread({}, image), {
                roundedBorder: true,
                layout: imagePosition === "bottom" || imagePosition === "top" ? "responsive" : undefined
            }))
        ]
    });
};
